import Skeleton from '@mui/material/Skeleton';
import React from 'react'
import { ResourceSkeletonWrapper } from './styles'

export const ResourceSkeleton = () => {
  return (
    <ResourceSkeletonWrapper>
      <Skeleton variant="rounded" width="100%" height="280px" sx={{borderRadius: "12px", bgcolor: "#CCC9C9"}} />
      <Skeleton variant="text" width="100%" height="25px" sx={{bgcolor: "#CCC9C9", marginTop:"7px"}}/>
      <Skeleton variant="text" width="100%" sx={{bgcolor: "#CCC9C9", marginTop:"-2px"}}/>
      <Skeleton variant="text" width="100%" sx={{bgcolor: "#CCC9C9", marginTop:"-2px"}}/>
    </ResourceSkeletonWrapper>
  )
}

export default ResourceSkeleton
